import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../lib/api';
import { setStoredToken, getStoredToken } from '../lib/authToken';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

export function LoginPage() {
  const navigate = useNavigate();
  useEffect(() => {
    if (getStoredToken()) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  const [email, setEmail] = useState('tafsir@evo-home.ch');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const { data } = await login(email.trim(), password);
      if (!data?.token) {
        setError('Unexpected response from server.');
        return;
      }
      setStoredToken(data.token);
      navigate('/', { replace: true });
    } catch (err) {
      const status = err.response?.status;
      if (!err.response) {
        setError('Cannot reach the server. Check your connection and that the API is running.');
        return;
      }
      if (status === 502 || status === 503 || status === 504) {
        setError('Bad gateway: the API is not reachable from nginx (often backend down or HTTPS site missing /api/ proxy). See deploy/DEPLOYMENT_GUIDE.md.');
        return;
      }
      const msg = err.response?.data?.detail;
      setError(typeof msg === 'string' ? msg : 'Sign-in failed. Check your email and password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-gray-50 px-4 py-10">
      <Card className="w-full max-w-md border-gray-200 shadow-sm">
        <CardHeader className="space-y-1">
          <CardTitle className="text-xl font-semibold tracking-tight">
            EvoNucleus P&L
          </CardTitle>
          <CardDescription>Sign in to continue</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="login-email">Email</Label>
              <Input
                id="login-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={submitting}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="login-password">Password</Label>
              <Input
                id="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={submitting}
                required
              />
            </div>
            {error ? (
              <p className="text-sm text-red-600" role="alert">
                {error}
              </p>
            ) : null}
            <Button type="submit" className="w-full bg-gray-900 text-white hover:bg-gray-800" disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
